import React from 'react';
import Button from '../../Forms/Button';

interface PreviewActionsProps {
    error: string;
    stamping: boolean;
    // Emitters
    onReturn: () => void;
    onSubmit: () => void;
}

function PreviewActions({ error, stamping, onReturn, onSubmit }: PreviewActionsProps) {
    return (
        <div className="actions">
            {
                error ?
                    <p className="message error">
                        <span className="error">
                            {error}
                        </span>
                    </p>
                    : (stamping ?
                        <p className="message success">
                            <span className="">
                                Facturando, espere...
                            </span>
                        </p>
                        : '')

            }
            <Button secondary={true} handleClick={onReturn}>
                <span>
                    Regresar
                </span>
            </Button>
            <Button primary={true} disabled={!!error || stamping} handleClick={onSubmit}>
                <span>
                    Emitir Factura
                </span>
            </Button>
        </div>
    )
}

export default PreviewActions;
